import Logo from "../components/mainPage/Logo";
import '../style/pages/denyPhones.css';

export default function DenyPhones () {
    return (
        <div className="prevent-sm-pohnes flex flex-center-center">
            <div className="center">
                <Logo mode={"dark"} flex={true} width={'50'} />
                <p>
                    This application is not available on mobile devices.
                    For access to the system for your business, please contact our sales team: <span className="text-weight-bold">+201121530044</span>
                </p>
                <p className="digital warning-text">
                    Please note that this system is designed to be used from a desktop or personal computer for optimal performance.
                    Any unusual or unauthorized activity may lead to permanent account suspension, which may result in loss of access.
                    Thank you for your understanding <span className="text-weight-bold">error-403 Forbidden</span>.
                </p>
            </div>
        </div>
    )
}